<!--
	@component
	the shared error paragraph for the {:catch} branch of a failed
	dealAndActual load on the offerer pub pages. doHandle rejects whatever
	publishPageError says and still rejects when publishPageError is false,
	so without a {:catch} the await block goes blank and the rejection
	renders nothing at all. OffererPubPageAccounting suppresses the error so
	a customer is never bounced to /login from a public route.
-->
<script lang="ts">
	import { t } from '../../i18n/i18n'
</script>

<p class="deal-load-error">{$t('Model.lot.noMatchHandling.genericError')}</p>

<style lang="scss">
	.deal-load-error {
		margin: 1.5rem 0;
		font-size: 1.125rem;
		line-height: 1.5;
	}
</style>
